import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "@environments/environment";

type BaseEntry = {
  text: string;
  value: number;
};

export type Institution = BaseEntry;
export type Laboratory = BaseEntry;

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private readonly baseUrl = `${environment.reportsUrl}/rest/ElabCases`;

  constructor(private http: HttpClient) {}

 
  private formatApiDate(date: Date, isEndOfDay: boolean = false): string {
    if (!date) return '';
    
    const d = new Date(date);
    if (isEndOfDay) {
      d.setHours(23, 59, 59, 0);
    } else {
      d.setHours(0, 0, 0, 0);
    }
    
  
    const isoString = d.toISOString().split('.')[0];
    
   
    const offset = '+01:00';
    return `${isoString}${offset}`;
  }

 
  getInstitutions(dateFrom: Date, dateTo: Date): Observable<Institution[]> {
    const params = new HttpParams()
      .set('DateFrom', this.formatApiDate(dateFrom))
      .set('DateTo', this.formatApiDate(dateTo, true));

    const url = `${this.baseUrl}/getUstanove`;
    return this.http.get<any[]>(url, { params });
  }

  
  getLaboratories(dateFrom: Date, dateTo: Date, ustanovaId: number | string): Observable<Laboratory[]> {
    const params = new HttpParams()
      .set('DateFrom', this.formatApiDate(dateFrom))
      .set('DateTo', this.formatApiDate(dateTo, true))
      .set('UstanovaId', ustanovaId.toString());

    const url = `${this.baseUrl}/getLaboratorije`;
    return this.http.get<any[]>(url, { params });
  }

 
  buildGrafanaUrl(dateFrom: Date | null, dateTo: Date | null, ustanovaId: number, laboratorijaId: number): string {

    let url = `${environment.grafanaUrl}/d/-VoHsr-Vk/elab?orgId=1&theme=light&kiosk`;

    if (ustanovaId) {
      url += `&var-Ustanova=${ustanovaId}`;
    }

    if (laboratorijaId) {
      url += `&var-Laboratorija=${laboratorijaId}`;
    }

    if (dateFrom && dateTo) {
      const from = new Date(dateFrom).getTime();
      const to = new Date(dateTo).getTime();
      
      url += `&from=${from}&to=${to}`;
    }

    return url;
  }
}